import React from 'react';

import { Paragraph } from '@uncinc/react-drupal-core';

import { WysiwygField } from '../../../components';
import './style.scss';

const ParagraphObjectives = ({ entity }) => {
  const title = entity.getIn(['field_title', 0, 'value']);
  const body = entity.getIn(['field_body', 0, 'processed']);
  const paragraphs = entity.getIn(['field_paragraphs']);

  return (
    <div className="Paragraph ParagraphObjectives">
      <h2 className="asH1">{title}</h2>

      {body && (
        <WysiwygField
          property="schema:text"
          className="ParagraphObjectives__body"
          html={body}
        />
      )}

      <div className="ParagraphObjectives__paragraphs">
        {paragraphs && paragraphs.map((item) => {
          const paragraph = item.get('entity');
          const paragraphId = item.get('target_id');
          return (
            <Paragraph key={paragraphId} entity={paragraph} id={paragraphId} />
          );
        })}
      </div>
    </div>
  );
};

export default ParagraphObjectives;
